<template>
  <v-layout row wrap my-3 mx-2>
    <v-flex xs12 md6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Build Template
        </v-card-title>
        <v-card-actions class="px-3">
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
          <v-progress-linear  height="10"  v-if="upload>0 && upload<100" color="green darken-3" v-model="upload"></v-progress-linear>
          <v-progress-linear  height="10"  v-if="loading && upload == 100" color="green darken-3" indeterminate></v-progress-linear>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap px-2>
          <v-flex xs12 px-1>
            <v-select
              :items="templates"
              v-model="selectedTemplate"
              label="Load a saved Template"
              append-outer-icon="add"
              @click:append-outer="newTemplate"
              solo
            ></v-select>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="Template Name"
              solo
              v-model="templateName"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="From Email"
              solo
              v-model="fromEmail"
              suffix="@"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-select
              :items="['4w7pc5z8gc.com']"
              label="Domain"
              solo
              v-model="fromDomain"
              append-outer-icon="add"
              @click:append-outer=""
            ></v-select>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="From name"
              solo
              v-model="fromName"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="Language"
              solo
              v-model="language"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="Footer"
              solo
              v-model="footerText"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="Button url"
              solo
              v-model="buttonURL"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="Image URL"
              solo
              v-model="imgURL"
              prepend-icon="cloud_upload"
              @click:prepend="pickFile('img')"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="logo URL"
              solo
              v-model="logoURL"
              prepend-icon="cloud_upload"
              @click:prepend="pickFile('logo')"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 px-1>
            <v-text-field
              label="Button Text"
              solo
              v-model="buttonText"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12 px-1>
            <v-text-field
              label="Email subject"
              solo
              v-model="emailSubject"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 pa-1>
            <span class="my-3">Use <span class="red--text">|Firstname|</span> &/OR <span class="red--text">|Lastname|</span> to include name</span>
            <v-textarea
              solo
              label="Message"
              v-model="sMessage"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn 
            outline 
            color="error" 
            dark
            v-if="selectedKey"
            @click="dialog = true"
          >delete template</v-btn>
          
          <v-btn 
            @click="saveTemplate()"  
            color="primary" 
            :loading="loading"
            dark>
            {{ selectedKey ? 'Update' : 'Save Template'}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Are You Sure?</v-card-title>
          <v-card-text>
            You are about to delete template {{ templateName }}, are you sure you want to do that?
            <div class="error white--text pa-2 ma-3">NOTE: all data associated with template {{ templateName }} will be deleted completely from our servers, and it will be impossible to restore it</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialog = false">cancel</v-btn>
            <v-btn 
              color="success" 
              outline 
              @click="()=>{ deleteTemplate(); dialog = false  }"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs12 md6 px-2>
      <v-card
        class="pa-2 mb-5 
        elevation-6"
        
      >
        <v-card-title class="headline white--text primary" >
          Preview
        </v-card-title>
        <div
          v-on:dragstart="getRight()" 
          @click.right="getRight()" 
          @click.left="getRight()"
        >
          <emailT
            :templateName="templateName"
            :logoURL="logoURL"
            :imgURL="imgURL"
            :emailBody="sMessage"
            :buttonURL="buttonURL"
            :buttonText="buttonText"
            :footerText="footerText"
          />
        </div>
        
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import { storageRef, firebase, db, auth } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import emailT from './emailTemplate'


export default {
  components:{emailT}, 
  data() {
    return {
      uploadURL:null,
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      qr:null,
      upload:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selected:[],
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      numbersMass:[],
      fileUploading:null,
      imgURL:null,
      logoURL:null,
      templateName:null,
      buttonURL:null,
      buttonText:null,
      footerText:null,
      emailSubject:null,
      fromEmail:null,
      fromDomain:null,
      fromName:null,
      language:null,
      emailSubject:null,
      selectedTemplate:[],
      templates:[],
      loadedTemplates:null,
      selectedKey:null,
      dialog:false
    }
  },
  methods: {
    getRight(e) {
      e = e || window.event;
      e.preventDefault()
    },
    deleteTemplate() {
      if(!this.selectedKey) return true
      db.ref('emails/templates')
      .update({[this.selectedKey]:null})
      .then(y=>{
        let index = this.templates.findIndex(x => x.value === this.selectedKey)
        console.log(index)
        this.templates.splice(index, 1)
        this.newTemplate()
      })
    },
    getTemplates(){
      return db.ref('emails/templates')
      .on('value', t=>{
        let templates = t.val()
        this.loadedTemplates = templates
        console.log(templates)
        for (const key in templates) {
            if (templates.hasOwnProperty(key)) {
              const template = templates[key];
              this.templates.push({
                text:template.templateName,
                value:key
              })
            }
        }
      })
    },
    saveTemplate(){
      let template = {
        imgURL: this.imgURL,
        logoURL: this.logoURL,
        templateName: this.templateName,
        emailBody: this.sMessage,
        buttonURL: this.buttonURL,
        buttonText: this.buttonText,
        footerText: this.footerText,
        emailSubject: this.emailSubject,
        fromEmail: this.fromEmail,
        fromDomain: this.fromDomain,
        fromName: this.fromName,
        language: this.language,
        emailSubject: this.emailSubject,
      }
      console.log(template)
      if(!this.selectedKey) {
        db.ref('emails/templates')
        .push(template)
        .then(x=>{
          this.newTemplate()
        })
      } else {
        db.ref('emails/templates/' + this.selectedKey)
        .update(template)
        .then(x=>{
          this.newTemplate()
        })
      }
    },
    goTo(path) {
      this.$router.push(path)
    },
    pickFile (f) {
      this.$refs.file.click ()
      this.fileUploading = f
    },
    loadFile(file){
      var file = file
      var metadata = {
        contentType: 'image/jpeg'
      };
      var uploadTask = storageRef.child('images/' + randomString(8, 'Aa#') + '.jpg').put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          if(this.fileUploading == 'img') {
            this.imgURL = downloadURL
          } else if(this.fileUploading == 'logo') {
            this.logoURL = downloadURL
          }
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFile(this.file)
				})
			} else {
				this.name = null
				this.fule = null
				this.uploadURL = null
			}
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    newTemplate(){
      this.imgURL = null
      this.logoURL =  null
      this.templateName =  null
      this.sMessage =  null
      this.buttonURL =  null
      this.buttonText =  null
      this.footerText =  null
      this.emailSubject = null
      this.fromEmail = null
      this.fromDomain =  null
      this.fromName =  null
      this.language =  null
      this.emailSubject =  null
      this.selectedKey =  null
      this.selectedTemplate =  null
    }
  },
  computed:{
    
  },
  watch:{
    selectedTemplate() {
      if (!this.selectedTemplate) return
      console.log(this.loadedTemplates[this.selectedTemplate])
      let t = this.loadedTemplates[this.selectedTemplate]
      this.imgURL = t.imgURL
      this.logoURL = t.logoURL
      this.templateName = t.templateName
      this.sMessage = t.emailBody
      this.buttonURL = t.buttonURL
      this.buttonText = t.buttonText
      this.footerText = t.footerText
      this.emailSubject = t.emailSubject
      this.fromEmail = t.fromEmail
      this.fromDomain = t.fromDomain
      this.fromName = t.fromName
      this.language = t.language
      this.emailSubject = t.emailSubject
      this.selectedKey = this.selectedTemplate
    }
  },
  created() {
    this.getTemplates() 
    let DB = (ref) => {
      return db.ref(ref)
      .once('value')
      .then(x=>{ return x.val()})
    } 

    
    DB('whatsapp/numbers').then(e=>{
      console.log(e)
    })
  }
}
</script>

<style>

</style>
